export const iconFontAwesomeMapsBriefcase = (
	<i className="fa-solid fa-briefcase"></i>
);
